import { MessageSquare, Calculator, X } from 'lucide-react';
import { NotificationCenter } from '../notifications/NotificationCenter';
import { UserMenu } from '../ui/UserMenu';
import { Avatar } from '../ui/Avatar';
import type { User } from '@auth0/auth0-react';

interface HeaderActionsProps {
  onToggleCalculator: () => void;
  onToggleChat: () => void;
  isChatOpen?: boolean;
  hideChat?: boolean;
  onToggleUserMenu: () => void;
  user: User | undefined;
  showUserMenu: boolean;
  onCloseUserMenu: () => void;
}

export function HeaderActions({
  onToggleCalculator,
  onToggleChat,
  isChatOpen = false,
  hideChat = false,
  onToggleUserMenu,
  user,
  showUserMenu,
  onCloseUserMenu
}: HeaderActionsProps) {
  return (
    <div className="flex items-center gap-4">
      <button 
        onClick={onToggleCalculator}
        className="text-muted-foreground hover:text-foreground transition-colors"
        title="Calculatrice"
      >
        <Calculator className="h-5 w-5" />
      </button>
      
      {/* Bouton Chat avec indicateur d'état — masqué si auditeur sans entreprise active */}
      {!hideChat && (
        <button 
          onClick={onToggleChat}
          className={`
            relative p-2 rounded-lg transition-all
            ${isChatOpen 
              ? 'bg-primary text-primary-foreground' 
              : 'text-muted-foreground hover:text-foreground hover:bg-muted'
            }
          `}
          title={isChatOpen ? "Fermer ADHA" : "Ouvrir ADHA"}
        >
          {isChatOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <>
              <MessageSquare className="h-5 w-5" />
              {/* Badge indicateur */}
              <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-primary rounded-full" />
            </>
          )}
        </button>
      )}

      <NotificationCenter />

      <div className="relative">
        <button 
          onClick={onToggleUserMenu}
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground"
        >
          <Avatar user={user} size="md" />
          <span className="hidden md:block">{user?.name}</span>
        </button>

        {showUserMenu && <UserMenu onClose={onCloseUserMenu} />}
      </div>
    </div>
  );
}